export const DEFAULT_NOTIFICATION_DURATION_MS = 4000;
export const FORM_DISPLAY_TIME_AFTER_NOTIFICATION = 1000;
export const FORM_DISPLAY_TIME_AFTER_SUBMIT =
  DEFAULT_NOTIFICATION_DURATION_MS + FORM_DISPLAY_TIME_AFTER_NOTIFICATION;
export const ALPHABETIC_WITH_SPACE_REGEX = /^[A-Za-z\s'-]+$/u;
export const MAX_NAME_LENGTH = 50;
